<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo-section">
        <div class="logo-wrapper">
          <img src="@/assets/logo.png" alt="订单管理系统" class="logo-img">
        </div>
        <h1 class="system-title">订单管理系统</h1>
        <p class="subtitle">欢迎回来</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">用户名</label>
          <input 
            type="text" 
            id="username" 
            v-model="formData.username" 
            placeholder="请输入用户名" 
            required
            autocomplete="username"
          >
        </div>
        
        <div class="form-group">
          <label for="password">密码</label>
          <input 
            type="password" 
            id="password" 
            v-model="formData.password" 
            placeholder="请输入密码" 
            required
            autocomplete="current-password"
          >
        </div>
        
        <button type="submit" class="login-btn">
          登录
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginPage',
  data() {
    return {
      formData: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions({
      login: 'user/login'
    }),
    
    async handleLogin() {
      try {
        // 简单的表单验证
        if (!this.formData.username || !this.formData.password) {
          this.$message.error('请输入用户名和密码')
          return
        }
        
        // 调用 /api/account/login GET 接口（通过代理转发）
        const response = await fetch('/api/account/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: this.formData.username,
            password: this.formData.password
          })
        })
        
        const result = await response.json()
        
        // 处理响应结果
        if (result.code === 200 && result.data && result.data.token) {
          // 存储返回的token到本地存储
          localStorage.setItem('jwt-token', result.data.token)
          // 存储permission到本地存储
          localStorage.setItem('user-permission', result.data.permission)
          
          // 更新Vuex store中的登录状态
          await this.login({
            username: this.formData.username,
            token: result.data.token,
            permission: result.data.permission
          })
          
          this.$router.push('/')
        } else {
          // 当code不为200时，使用Element UI错误提示
          this.$message.error(result.msg || '登录失败，请重试')
        }
      } catch (error) {
        this.$message.error('登录失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');

/* 主容器 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #F7F5F1;
  padding: 40px 20px;
  position: relative;
}

/* 登录框 */
.login-box {
  background: #FFFFFF;
  padding: 60px 50px;
  border-radius: 8px;
  border: 1px solid #E7E3DA;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 460px;
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Logo区域 */
.logo-section {
  text-align: center;
  margin-bottom: 48px;
}

.logo-wrapper {
  margin-bottom: 24px;
}

.logo-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.system-title {
  font-family: 'Playfair Display', serif;
  color: #1E2227;
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 8px 0;
  letter-spacing: -0.02em;
}

.subtitle {
  font-family: 'Inter', sans-serif;
  color: #6B7077;
  font-size: 15px;
  font-weight: 400;
  margin: 0;
}

/* 表单 */
.login-form {
  margin-top: 0;
}

.form-group {
  margin-bottom: 24px;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #1E2227;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #E7E3DA;
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  transition: all 0.2s ease;
  background: #FFFFFF;
  color: #1E2227;
  box-sizing: border-box;
}

.form-group input:focus {
  border-color: #3C5A78;
  outline: none;
  box-shadow: 0 0 0 3px rgba(60, 90, 120, 0.08);
}

.form-group input::placeholder {
  color: #6B7077;
  font-weight: 400;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  padding: 13px 24px;
  background: #3C5A78;
  color: #FFFFFF;
  border: none;
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;
}

.login-btn:hover {
  background: #2E4760;
}

.login-btn:active {
  transform: translateY(1px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-container {
    padding: 20px 15px;
  }
  
  .login-box {
    padding: 48px 36px;
    max-width: 100%;
  }
  
  .system-title {
    font-size: 28px;
  }
  
  .logo-img {
    width: 70px;
    height: 70px;
  }
}

@media (max-width: 480px) {
  .login-box {
    padding: 40px 28px;
  }
  
  .system-title {
    font-size: 26px;
  }
  
  .subtitle {
    font-size: 14px;
  }
  
  .form-group input {
    padding: 11px 14px;
    font-size: 14px;
  }
  
  .login-btn {
    padding: 12px 20px;
    font-size: 14px;
  }
}
</style>